
export default {
  container: {
    textAlign: 'center',
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#0288D1',
    height: '100vh',
    flexDirection: 'column',
    backgroundImage: `url(/images/tile.png)`,
    backgroundRepeat: 'repeat',
  },
  tenant: {
    cursor: 'pointer',
  },
  businessIcon: {
    // height: 300,
    // width: 300,
    fontSize: 30,
    color: '#0288D1',
  },
  businessLogo: {
    height: 30,
    width: 30,
  },
  newAccount: {
    marginTop: 60,
  },
  logout: {
    width: 300,
    marginTop: 30,
  },
  register: {
    width: 300,
    marginTop: 10,
  },
  tenantItem: {
    height: 53,
    textAlign: 'left',
    minWidth: 300,
  },
  paper: {
    marginTop: 30,
    padding: 30,
  },
  noTenants: {
    // marginTop: 20,
    backgroundColor: 'red',
    color: 'white',
    padding: 10,
    display: 'flex',
    alignItems: 'center',
  },
  warningIcon: {
    padding: 5,
  },
};



// WEBPACK FOOTER //
// ./src/components/Authentication/SelectTenant/styles.js